import OrgManagementOrgModal from './OrgManagementOrgModal';
import OrgManagementSiteTagModal from './OrgManagementSiteTagModal';
import OrgManagementSiteModal from './OrgManagementSiteModal';
import OrgManagementDeleteModal from './OrgManagementDeleteModal';
import OrgManagementInviteUser from './OrgManagementInviteUser';
import OrgManagementGenerateModal from './OrgManagementGenerateModal';
import OrgTreePreviewModal from './OrgTreePreviewModal'

const ModalComponents = ({
  info,
  modalStatus,
  handleModals,
  submitModal
}) => {

  return (
    <>
      {modalStatus?.org?.status &&
        <OrgManagementOrgModal {...{ info, modalStatus, handleModals, submitModal }} />
      }
      {modalStatus?.tag?.status &&
        <OrgManagementSiteTagModal {...{ info, modalStatus, handleModals, submitModal }} />
      }
      {modalStatus?.site?.status &&
        <OrgManagementSiteModal {...{ info, modalStatus, handleModals, submitModal }} />
      }
      {modalStatus?.delete?.status &&
        <OrgManagementDeleteModal {...{ modalStatus, handleModals, submitModal }} />
      }
      {modalStatus?.invite?.status &&
        <OrgManagementInviteUser {...{ info, modalStatus, handleModals, submitModal }} />
      }
      {modalStatus?.generate?.status &&
        <OrgManagementGenerateModal {...{ info, modalStatus, handleModals }} />
      }
      {modalStatus?.preview?.status &&
        <OrgTreePreviewModal {...{ info, modalStatus, handleModals }} />
      }
    </>
  );
};

export default ModalComponents;